import * as React from "react";
import { IconChevronLeft } from "../../components/icons.jsx";
import { IconTreasureChest, IconSparkles, IconX, IconArrowRight, IconRefresh } from "@tabler/icons-react";
import { EventToast } from "./EventToast.jsx";
import "./event-chest.css";

const number = value => Number(value).toLocaleString("ru-RU");
const range = ([low, high]) => low === high ? number(low) : `${number(low)}–${number(high)}`;

function ChestRewards({ reward, next }) {
  return <article className={`event-chest-rewards ${next ? "is-next" : "is-current"}`} aria-current={next ? undefined : "step"}>
    <header><span>{next ? "Следующий уровень" : "Текущий уровень"}</span><h3>Уровень {reward.level}</h3></header>
    <div className="event-chest-resources">
      <div><img src="/assets/resource-emojis/card.webp" alt="" /><b>{range(reward.spins)}</b><span>Крутки</span></div>
      <div><img src="/assets/resource-emojis/crystal.webp" alt="" /><b>{range(reward.gems)}</b><span>Кристаллы</span></div>
      {reward.currency?.[1] > 0 && <div><img src="/assets/home-halloween/pumpkin-v2.webp" alt="" /><b>{range(reward.currency)}</b><span>Тыквы</span></div>}
    </div>
    {reward.limitedChance > 0 && <p className="event-chest-limited"><span aria-hidden="true">✦</span> Лимитка <b>{reward.limitedChance}%</b></p>}
    {reward.secondLimitedChance > 0 && <p className="event-chest-limited">Вторая лимитка <b>{reward.secondLimitedChance}%</b></p>}
  </article>;
}

export function EventChestPage({ event, busy, loading, pending, error, notice, onDismissNotice, onReload, onChange, onBack, showBack }) {
  const [confirm, setConfirm] = React.useState(false);
  const dialog = React.useRef(null);
  const hintId = React.useId();
  const openButton = React.useRef(null);
  const chest = event.chest;
  const blocked = loading || !!busy;
  React.useEffect(() => {
    if (!confirm) return;
    const element = dialog.current;
    element.showModal();
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { element.close(); document.body.style.overflow = previous; openButton.current?.focus(); };
  }, [confirm]);
  return <section className="halloween-event-page event-chest-page" aria-label="Рундук события" aria-busy={blocked}>
    <header className="event-chest-heading">
      {showBack && <button type="button" className="event-chest-back" onClick={onBack} aria-label="К событию"><IconChevronLeft aria-hidden="true" /></button>}
      <h2>Рундук</h2>
      <button type="button" className="event-chest-info" popoverTarget={hintId} aria-label="Правила рундука">?</button>
      <span className="event-chest-wallet"><img src="/assets/home-halloween/pumpkin-v2.webp" alt={event.currencyName} /><b>{number(event.currency)}</b></span>
    </header>
    <div id={hintId} popover="auto" className="event-chest-hint">
      <h3>Как работает рундук</h3>
      <p>Награды выдаются при открытии. После открытия уровень сбрасывается до 1.</p>
      <p>Повторное открытие доступно с 3-го уровня. До открытия можно продолжать прокачку за тыквы.</p>
      {chest.openingNotice && <p>{chest.openingNotice}</p>}
      {!event.active && <p>Событие завершено. Рундук недоступен.</p>}
    </div>
    <EventToast message={notice} onDismiss={onDismissNotice} />
    <div className="event-chest-main">
    <div className="event-chest-hero"><img src="/assets/event-chest/chest.webp" alt={chest.name} /></div>
    <div className="event-chest-level">Уровень {chest.level} <span>из {chest.maxLevel}</span></div>
    {error && <div className="event-chest-message" role="alert"><p>{error}</p><button type="button" disabled={blocked} onClick={onReload}>Обновить</button></div>}
    {pending ? <button type="button" className="event-chest-upgrade" disabled={blocked || !event.active} onClick={() => onChange(pending.action)}>{busy ? "Проверяем…" : "Повторить незавершённый запрос"}</button>
      : chest.next ? <button type="button" className="event-chest-upgrade" disabled={blocked || !chest.canUpgrade} onClick={() => onChange("upgrade")}>
        {busy === "chest:upgrade" ? "Прокачиваем…" : <>Прокачать <span>· {event.currencyEmoji} {number(chest.upgradeCost)}</span></>}
      </button> : <p className="event-chest-maximum">Максимальный уровень</p>}
    {!pending && <button ref={openButton} type="button" className="event-chest-open event-chest-open-reward" disabled={blocked || !chest.canOpen} onClick={() => setConfirm(true)}>
      <span className="event-chest-open-symbol" aria-hidden="true"><IconTreasureChest /></span>
      <span>Открыть и забрать награды</span>
      <IconSparkles className="event-chest-open-sparkles" aria-hidden="true" />
    </button>}
    </div>
    <div className="event-chest-reward-pair"><ChestRewards reward={chest.current} />{chest.next && <ChestRewards reward={chest.next} next />}</div>
    {confirm && <dialog ref={dialog} className="event-chest-dialog" aria-labelledby="event-chest-confirm-title" aria-describedby="event-chest-confirm-reset" onCancel={() => setConfirm(false)} onClick={e => { if (e.target === e.currentTarget) setConfirm(false); }}>
      <button type="button" className="event-chest-confirm-close" onClick={() => setConfirm(false)} aria-label="Закрыть подтверждение"><IconX aria-hidden="true" /></button>
      <header className="event-chest-confirm-overview">
        <div className="event-chest-confirm-art"><img src="/assets/event-chest/chest.webp" alt="" /></div>
        <div><small>ТВОИ СОКРОВИЩА</small><h3 id="event-chest-confirm-title">Открыть рундук?</h3><p>Забери награды этого уровня</p></div>
      </header>
      <div className="event-chest-confirm-rewards"><ChestRewards reward={chest.current} /></div>
      <div className="event-chest-confirm-reset" id="event-chest-confirm-reset">
        <div><IconRefresh aria-hidden="true" /><span>После открытия</span><b>{chest.level} <IconArrowRight aria-hidden="true" /> 1 ур.</b></div>
        <p>Уровень сбросится до 1. Повторное открытие — с уровня 3.</p>
      </div>
      <div className="event-chest-confirm-actions">
        <button type="button" className="event-chest-open event-chest-open-reward" onClick={() => { setConfirm(false); onChange("open"); }}><IconTreasureChest aria-hidden="true" />Да, открыть<IconSparkles className="event-chest-open-sparkles" aria-hidden="true" /></button>
        <button type="button" className="event-chest-open" autoFocus onClick={() => setConfirm(false)}>Продолжить прокачку</button>
      </div>
    </dialog>}
  </section>;
}
